<template>
    <div class="flashsale" v-if="isLoaded && isHaveItem">
        <FlashSaleBar :campaign="campaigns"></FlashSaleBar>
        <div class="flashSale-slider">
            <div class="text-see-more" @click="clickSeeMore()"><span class="see-more">{{ lbl.home.seemore }}</span> ></div>
            <FlashSaleSlider :campaigns="campaigns" :lbl="lbl"></FlashSaleSlider>
        </div>
    </div>
</template>

<script>
import Account from "@/helper/AccountHelper.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
import Locale from "@/helper/locale/Locale.js"
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/service/config/CampaignConfigModel.js";
import FlashSaleBar from './Flashsale/FlashSaleBar.vue';
import FlashSaleSlider from './Flashsale/FlashSaleSlider.vue';
export default {
    name: "FlashSale",
    components: {
        FlashSaleBar,
        FlashSaleSlider
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            campaigns : [],
            isLoaded : false,
            isHaveItem : false,
        }
    },
    created: function () {
        this.blobConfig = Account.getCacheBlob()
        this.initialFlashsale()
    },
    methods: {
        initialFlashsale: function () {
            this.flashsaleListConfig = {};
            this.flashsaleListFilterConfig = {};

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.blobConfig.flash_sale_campaign_list_config)
                .setSeeMore(false);

                this.listConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder();
            this.filterConfig = filterConfig.create();

            this.getList()
        },
        getList: function() {
            if (!this.listConfig.strConfigList) return;

            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig,  this.filterConfig)
                .then((campaigns) => {
                this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                //check is there are more campaign.
                if (campaigns &&
                    campaigns.length < this.listConfig.defaultTopAmount)
                    this.listConfig.isSeeMoreEnable = false;

                //reinitialize list if no skip.
                if (this.listConfig.intSkip ==
                    this.listConfig.defaultTopAmount)
                    this.campaigns = [];

                for (var campaign of campaigns) {
                    //TODO: Add GA Tracking.
                    this.campaigns.push(campaign);
                }

                this.isLoaded = true;
                this.isHaveItem = this.campaigns.length > 0
                    ? true
                    : false;
            }).catch(error => {
                this.isLoaded = true;
                this.isHaveItem = false;
                 console.log(error);
            });
        },
        clickSeeMore: function() {
            this.$router.push('/flashsale')
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
    .flashsale {
        padding: 20px 0;
        .flashSale-slider {
            background-color: white;
            border-bottom: solid 5px #f8a51b;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            padding: 0 24px 24px;
            .text-see-more {
                text-align: right;
                padding: 16px 0;

                .see-more {
                    text-decoration: underline;
                    padding-right: 10px;
                    color: $a-black-333333;
                }
            }
        }
    }
</style>
